const OPTIONS_TYPES = {
  PRODUCT: 'PRODUCT',
  LOCATION: 'LOCATION',
  CATEGORY: 'CATEGORY'
}

export default OPTIONS_TYPES
